import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { TemplatesComponent } from './Presentors/PageComponent/templates/templates.component';
import { AttachmentsComponent } from './Presentors/PageComponent/attachment-pages/attachments/attachments.component';
import { QuotesComponent } from './Presentors/PageComponent/quotes/quotes.component';
import { BulkInviteComponent } from './Presentors/PageComponent/bulk-invite-pages/bulk-invite/bulk-invite.component';
import { BulkInviteTemplateComponent } from './Presentors/PageComponent/bulk-invite-pages/bulk-invite-template/bulk-invite-template.component';
import { PreviewComponent } from './Presentors/PageComponent/preview/preview.component';
import { SendComponent } from './Presentors/PageComponent/send/send.component';
import { ResultComponent } from './Presentors/PageComponent/result/result.component';
import { StatusComponent } from './Presentors/PageComponent/status/status.component';
import { AdminPageComponent } from './Presentors/PageComponent/admin-page/admin-page.component';
import { ClosePopupComponent } from './Presentors/SharedComponent/close-popup/close-popup.component';
import { MaintenancePageComponent } from './Presentors/PageComponent/maintenance-page/maintenance-page.component';

const app_routes: Routes = [
  { path: 'templates', component: TemplatesComponent, data: { title: 'Templates' } },
  { path: 'attachments', component: AttachmentsComponent, data: { title: 'Attachments' } },
  { path: 'quotes', component: QuotesComponent, data: { title: 'Quotes' } },
  { path: 'bulk_invite', component: BulkInviteComponent, data: { title: 'Bulk Invite' } },
  {
    path: 'bulk_invite_template',
    component: BulkInviteTemplateComponent,
    data: { title: 'Bulk Invite Template' }
  },
  { path: 'preview', component: PreviewComponent, data: { title: 'Preview' } },
  { path: 'send', component: SendComponent, data: { title: 'Send' } },
  { path: 'result', component: ResultComponent, data: { title: 'Result' } },
  { path: 'status', component: StatusComponent, data: { title: 'Status' } },
  { path: 'admin', component: AdminPageComponent, data: { title: 'Admin Page' } },
  { path: 'maintenance', component: MaintenancePageComponent, data: { title: 'Maintenance' } },
  { path: 'close_popup', component: ClosePopupComponent, data: { title: 'Close Popup' } },
  { path: '**', component: TemplatesComponent, data: { title: 'Templates' } }
];

@NgModule({
  imports: [RouterModule.forRoot(app_routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
